// get game configuration
export async function getConfig(eventName) {
  const url =
    process.env.REACT_APP_ROOT_ENDPOINT + process.env.REACT_APP_CONFIG_ENDPOINT;
  console.log("endpoint to be called ", url);
  const params = new URLSearchParams({
    eventName: eventName,
  });
  try {
    const response = await fetch(`${url}?${params}`);
    const data = await response.json();
    return data[0];
  } catch (error) {
    console.error(error);
    // Gestion de l'erreur
  }
}

//save user infos after forms submit
export async function postUser(
  firstname,
  lastname,
  address,
  phone,
  email,
  birthDate,
  postalCode,
  code,
  optin,
  idGain,
  idConfig
) {
  try {
    const url =
      process.env.REACT_APP_ROOT_ENDPOINT +
      process.env.REACT_APP_USERS_ENDPOINT;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstname: firstname,
        lastname: lastname,
        address: address,
        phone: phone,
        email: email,
        birthDate: birthDate,
        postalCode: postalCode,
        code: code,
        optin: optin,
        idGain: idGain,
        idConfig: idConfig,
      }),
    });

    if (response.ok) {
      console.log("Data sent successfully:", await response.json());
    } else {
      console.error("Error sending data:", response.statusText);
    }
  } catch (error) {
    console.error("Error sending data:", error);
  }
}

//check if the code is valid or already used
export async function checkCode(idConfig, code) {
  const url =
    process.env.REACT_APP_ROOT_ENDPOINT + process.env.REACT_APP_CODES_ENDPOINT;
  const params = new URLSearchParams({
    idConfig: idConfig,
    code: code,
  });
  try {
    const response = await fetch(`${url}?${params}`);
    const data = await response.json();
    console.log("checkcode data", data);
    let res = {};
    if (data.length === 0) {
      console.log("code inconnu");
      res = { validity: false };
    } else {
      console.log("code connu");
      res = { validity: !data[0].usedStatus };
    }
    return res;
  } catch (error) {
    console.error(error);
    // Gestion de l'erreur
  }
}

// get gains
export async function getGains(idConfig) {
  const url =
    process.env.REACT_APP_ROOT_ENDPOINT + process.env.REACT_APP_GAINS_ENDPOINT;
  const params = new URLSearchParams({
    idConfig: idConfig,
  });
  try {
    const response = await fetch(`${url}?${params}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    // Gestion de l'erreur
  }
}

//send email to winners
export async function sendMail(email, gain) {
  try {
    const url =
      process.env.REACT_APP_ROOT_ENDPOINT +
      process.env.REACT_APP_SENDMAIL_ENDPOINT;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        Gains: {
          remainingQty: gain.remainingQty,
          descriptionTxt: gain.descriptionTxt,
          initialQty: gain.initialQty,
          image: gain.image,
          id: gain.id,
          indication1: gain.indication1,
          indication2: gain.indication2,
          idConfig: gain.idConfig,
          gainsName: gain.gainsName,
        },
      }),
    });

    if (response.ok) {
      console.log("Data sent successfully:", await response.json());
    } else {
      console.error("Error sending data:", response.statusText);
    }
  } catch (error) {
    console.error("Error sending data:", error);
  }
}
